import { Component, Decision, State } from '../structure';

import { getToken } from './getToken';
import { ThemeProps } from './types';

export const getComponentToken =
    <V extends string>(componentName: Component) =>
    (decision: Decision, { variant, state }: { variant?: V; state?: State } = {}) =>
    (props: ThemeProps) =>
        getToken(props, componentName, decision, { variant, state });
